import * as React from 'react';
export const boltSvg = React.forwardRef(function boltSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#000',
      style: {
        fill: 'light-dark(#000,#fff)',
      },
      fillRule: 'evenodd',
      d: 'M17.333 23.595c-1.448 0-2.869-.517-3.686-1.629l-.288 1.311-5.313 2.771.573-2.77 3.87-17.23h4.739l-1.37 6.073c1.105-1.19 2.133-1.629 3.45-1.629 2.842 0 4.738 1.836 4.738 5.195 0 3.462-2.186 7.908-6.713 7.908m1.818-6.928c0 1.603-1.158 2.817-2.659 2.817-.842 0-1.605-.31-2.106-.852l.737-3.179c.552-.543 1.185-.854 1.922-.854 1.132 0 2.106.827 2.106 2.068',
      clipRule: 'evenodd',
    }),
  );
});
boltSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var bolt = {
  category: 'brand',
  colorable: false,
  name: 'bolt',
  svg: boltSvg,
};
